import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
});

const DataTable = ({funds}) => {
    const classes = useStyles();

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="fondos">
                <TableHead>
                <TableRow>
                    <TableCell>Rut</TableCell>
                    <TableCell>Fondo</TableCell>
                    <TableCell>Serie</TableCell>     
                    <TableCell>Característica</TableCell>               
                </TableRow>
                </TableHead>
                <TableBody>
                {funds.map((row, i) => (
                    <TableRow key={i}>
                        <TableCell>{row.rut}</TableCell>
                        <TableCell>{row.entidad}</TableCell>
                        <TableCell>{row.serie}</TableCell> 
                        <TableCell>{row.caracteristicas}</TableCell>                   
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DataTable;

